export default function Contentgallery() {
  Alpine.data("contentgallery", () => ({
    flkty: null,

    init() {
      this.$nextTick(() => {
        const observer = new IntersectionObserver(
          async (entries, obs) => {
            if (!entries[0].isIntersecting) return;
            obs.disconnect();
            const { default: Flickity } = await import("flickity");
            this.flkty = new Flickity(this.$refs.slider, {
              cellAlign: "center",
              wrapAround: true,
              prevNextButtons: false,
              pageDots: false,
              draggable: true,
              contain: false,
            });
          },
          { rootMargin: "1000px" },
        );

        observer.observe(this.$refs.slider);
      });
    },
    prev() {
      this.flkty.prev();
    },
    next() {
      this.flkty.next();
    },
    destroy() {
      if (this.flkty) {
        this.flkty.destroy();
        this.flkty = null;
      }
    },
  }));
}
